var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"btn_v2 loading-btn",class:[{loading: _vm.loading}, _vm.couleur],on:{"click":function($event){return _vm.launchAction()}}},[(_vm.loading)?_c('Loading'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }